export const AELTERE_VERSION = 1;
export const ALT_VERSION = 2;
export const AKTUELL_VERSION = 3;
export const NEXT_VERSION = 4;

export const BEGONNEN_VM_DOWNLOAD_CENTER_DATE = '2023-01-02';

export const ANLAGE_VM_REQUIRED_FROM = '2026-07-01';

export const UPDATE_VERSION_START_DATE_NEXT = '2023-07-01';
export const UPDATE_VERSION_START_DATE_AKTUELL = '2022-08-01';
export const UPDATE_VERSION_START_DATE_ALT = '2021-08-01';
export const UPDATE_VERSION_START_DATE_AELTERE = '2018-01-01';
